import axios from 'axios';
import { handleAdminDashboardHttp401 } from '../lib/adminSession';
import { getAdminConsoleToken } from '../lib/adminConsoleToken';
import { isOidcAdminAuth } from '../lib/oidc/oidcConfig';
import { attachOidcBearer, handleOidcAxiosError } from '../lib/oidc/oidcAxios';

/**
 * Base URL for income-verification dashboard routes.
 * - Empty: same-origin `/api/income-verification/...` (Vite proxy in dev).
 * - Absolute: direct host calls for staging/UAT checks.
 */
export function incomeVerificationDashboardBaseUrl(): string {
  const raw = import.meta.env.VITE_INCOME_VERIFICATION_API_BASE as
    | string
    | undefined;
  return typeof raw === 'string' ? raw.trim().replace(/\/$/, '') : '';
}

export const incomeVerificationDashboardHttp = axios.create({
  baseURL: incomeVerificationDashboardBaseUrl(),
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

incomeVerificationDashboardHttp.interceptors.request.use((config) => {
  if (isOidcAdminAuth()) return attachOidcBearer(config);
  const t = getAdminConsoleToken();
  if (t) (config.headers as Record<string, string>).Authorization = `Bearer ${t}`;
  return config;
});

incomeVerificationDashboardHttp.interceptors.response.use(
  (r) => r,
  (err: unknown) =>
    isOidcAdminAuth()
      ? handleOidcAxiosError(incomeVerificationDashboardHttp, err)
      : handleAdminDashboardHttp401(err),
);
